import { RouteObject } from "react-router-dom";

const epkRoutes: RouteObject[] = [
	{ path: "/izlazne-posiljke/epk-konfiguracija", lazy: () => import("@/pages/OutgoingShipments/ePK/EpkConfigurationPage") },
	{ path: "/izlazne-posiljke/epk-datoteke", lazy: () => import("@/components/OutgoingShipments/ePK/EpkFiles") }
];

export default epkRoutes;
